module.exports = __webpack_public_path__ + "img/download.d6a142f0.svg";